import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import classNames from 'classnames';
import React, { Component } from 'react';
import { inputVarientType } from '../constants';
import Icon from '../Icon/Icon';
var css = {
  "inputContainer": "rui-Bz2UM",
  "inputWrapper": "rui-tLDMy",
  "primaryHighlightInput": "rui-ou7AH",
  "secondaryHighlightInput": "rui-DioCR",
  "roundedInputPixel": "rui-IozmQ",
  "saveSpaceForIcons": "rui-BoFpM",
  "input": "rui-2brBP",
  "disabled": "rui-WXtE8",
  "highlightInput": "rui-SP9uI",
  "icon": "rui-UgU64",
  "validated": "rui-ZSwKI",
  "primaryFocus": "rui-WijxI",
  "secondaryFocus": "rui-iv9y3",
  "iconClick": "rui-E2wZj",
  "fill": "rui-Jfwuv",
  "hintContainer": "rui-4jgcG",
  "mt-8": "rui-CRHo8",
  "lengthCounter": "rui-pzHe1",
  "primaryHintText": "rui-DTzlG",
  "secondaryHintText": "rui-rYMOY",
  "text": "rui-IlMwo",
  "primaryError": "rui-TM7wx",
  "secondaryError": "rui-6vOKn",
  "errorIcon": "rui-HZKov"
};
var LabelAndHint = /*#__PURE__*/function (_Component) {
  function LabelAndHint() {
    var _this;
    _classCallCheck(this, LabelAndHint);
    _this = _callSuper(this, LabelAndHint, arguments);
    _this.state = {
      focus: false,
      pristine: _this.props.pristine
    };
    _this.onFocus = function (event) {
      _this.setState({
        focus: true,
        pristine: false
      });
      _this.props.onFocus(event);
    };
    _this.onBlur = function (event) {
      _this.setState({
        focus: false
      });
      _this.props.onBlur(event);
    };
    return _this;
  }
  _inherits(LabelAndHint, _Component);
  return _createClass(LabelAndHint, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        direction = _this$props.direction,
        disabled = _this$props.disabled,
        errorText = _this$props.errorText,
        highlightInput = _this$props.highlightInput,
        highlightOnBlur = _this$props.highlightOnBlur,
        hintText = _this$props.hintText,
        icon = _this$props.icon,
        iconViewBox = _this$props.iconViewBox,
        iconClick = _this$props.iconClick,
        iconClickClassName = _this$props.iconClickClassName,
        onIconClick = _this$props.onIconClick,
        id = _this$props.id,
        label = _this$props.label,
        maxLength = _this$props.maxLength,
        renderElement = _this$props.render,
        saveSpaceForIcons = _this$props.saveSpaceForIcons,
        value = _this$props.value,
        dataAutId = _this$props.dataAutId,
        className = _this$props.className,
        containerClassName = _this$props.containerClassName,
        category = _this$props.category,
        showErrorIcon = _this$props.showErrorIcon,
        roundedInputPixel = _this$props.roundedInputPixel,
        hideMaxLength = _this$props.hideMaxLength,
        hintTextClass = _this$props.hintTextClass;
      var iconEl = null;
      var inputStateCss = '';
      if (icon) {
        iconEl = /*#__PURE__*/React.createElement("div", {
          className: css.icon
        }, /*#__PURE__*/React.createElement(Icon, {
          icon: icon,
          color: "accentDark",
          size: 16,
          viewBox: iconViewBox
        }));
      } else if (iconClick) {
        iconEl = /*#__PURE__*/React.createElement("div", {
          className: css.iconClick,
          onClick: onIconClick,
          onKeyPress: onIconClick,
          tabIndex: 0,
          role: "button"
        }, /*#__PURE__*/React.createElement(Icon, {
          icon: iconClick,
          color: "accentDark",
          direction: direction,
          size: 16,
          overrideClassName: iconClickClassName
        }));
      }
      if (!this.state.pristine && value && highlightOnBlur) {
        inputStateCss = css.validated;
      }
      if (this.state.focus) {
        inputStateCss = css["".concat(category, "Focus")];
      }
      if (errorText) {
        inputStateCss = css["".concat(category, "Error")];
      }
      if (disabled) {
        inputStateCss = css.disabled;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: classNames([css.inputContainer, inputStateCss, className])
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: id
      }, label), /*#__PURE__*/React.createElement("div", {
        className: classNames(containerClassName, css.inputWrapper, _defineProperty(_defineProperty(_defineProperty({}, css.saveSpaceForIcons, saveSpaceForIcons), css["".concat(category, "HighlightInput")], highlightInput), css.roundedInputPixel, roundedInputPixel))
      }, renderElement(css.input, iconEl, this.onFocus, this.onBlur)), /*#__PURE__*/React.createElement("div", {
        className: classNames(css.hintContainer, hintTextClass, _defineProperty({}, css['mt-8'], category === inputVarientType.SECONDARY))
      }, /*#__PURE__*/React.createElement("span", {
        className: classNames(css.text, css["".concat(category, "HintText")]),
        "data-aut-id": dataAutId
      }, showErrorIcon && errorText && /*#__PURE__*/React.createElement(Icon, {
        icon: 'attentionHaired',
        color: "error",
        iconClass: css.errorIcon,
        size: 16
      }), errorText || hintText), !hideMaxLength && maxLength && /*#__PURE__*/React.createElement("span", {
        className: classNames(css.lengthCounter, css["".concat(category, "HintText")])
      }, "".concat(value === null || value === void 0 ? void 0 : value.length, " / ").concat(maxLength))));
    }
  }]);
}(Component);
LabelAndHint.defaultProps = {
  className: '',
  direction: null,
  disabled: false,
  errorText: '',
  highlightInput: true,
  highlightOnBlur: false,
  hintText: '',
  icon: null,
  iconClick: null,
  iconClickClassName: '',
  id: '',
  label: '',
  maxLength: null,
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onIconClick: function onIconClick() {},
  pristine: true,
  saveSpaceForIcons: false,
  value: '',
  dataAutId: '',
  containerClassName: '',
  category: inputVarientType.PRIMARY,
  showErrorIcon: false,
  roundedInputPixel: false,
  hideMaxLength: false,
  hintTextClass: ''
};
export default LabelAndHint;